__turbopack_context__.v({
  "className": "dosis_db3e7ff1-module__yjUgsa__className",
  "variable": "dosis_db3e7ff1-module__yjUgsa__variable",
});
